import { AnimatePresence } from 'framer-motion';
import { ItemCard } from '@/components/ItemCard/ItemCard';
import type { ItemSummary } from '@/types';

interface ItemGridProps {
  items: ItemSummary[];
  isLoading: boolean;
  onOpen: (id: number) => void;
  emptyLabel: string;
}

export function ItemGrid({ items, isLoading, onOpen, emptyLabel }: ItemGridProps) {
  return (
    <main className="grid grid-cols-1 kiosk:grid-cols-2 gap-3 kiosk:gap-[2.4vw] px-4 kiosk:px-[3vw] pt-4 kiosk:pt-[2.4vw] pb-6 kiosk:pb-[6vw]">
      <AnimatePresence mode="popLayout">
        {items.map((item) => (
          <ItemCard key={item.id} item={item} onOpen={onOpen} />
        ))}
      </AnimatePresence>

      {!isLoading && items.length === 0 && (
        <p className="col-span-full text-center text-kiosk-muted text-kiosk-base mt-8 kiosk:mt-[4vw]">{emptyLabel}</p>
      )}
    </main>
  );
}
